import * as THREE from "three";

class Video {
  static createVideo(name, source) {
    const videoElement = document.createElement("video");
    videoElement.src = source;
    videoElement.autoplay = true;
    videoElement.loop = true;
    videoElement.muted = true;
    videoElement.controls = true;
    videoElement.playsInline = true;
    videoElement.crossOrigin = "anonymous";

    const videoTexture = new THREE.VideoTexture(videoElement);
    videoTexture.encoding = THREE.sRGBEncoding;

    const geometry = new THREE.PlaneGeometry(16, 9);

    const material = new THREE.MeshBasicMaterial({map: videoTexture});
    material.side = THREE.DoubleSide;

    const video = new THREE.Mesh(geometry, material);
    video.position.set(0, 5, 0);
    video.castShadow = true;
    video.receiveShadow = true;
    video.name = name;
    video.userData.canCollide = false;
    video.userData.isKinematic = true;
    video.userData.type = "video";
    video.userData.src = videoElement.src;
    video.userData.isDoubleSide = true;
    video.userData.isVideoMute = false;
    video.userData.isVideoAutoPlay = true;

    return video;
  }
}
export default Video;
